<template>
  <aha-modal
    size="md"
    @hide="$emit('hide')"
    title="You can only now view this presentation"
    class="be-taken-over-modal"
  >
    <p class="mb-2">
      While you were editing, this person took over the presentation:
    </p>
    <div class="flex items-center p-2 mb-3 bg-secondary-10">
      <aha-avatar
        class="mr-2 text-lg"
        :name="presenter.name"
        :image="presenter.avatar"
        :id="presenter.id"
        :width="36"
        :height="36"
      />
      <div class="flex flex-col">
        <span class="font-bold">
          <strong>{{ presenter.name }}</strong>
        </span>
        <p>{{ presenter.email }}</p>
      </div>
    </div>
    <p>Only they can now edit and present it.</p>
    <template #action>
      <aha-button
        @click="$emit('hide')"
      >
        OK, I understand
      </aha-button>
    </template>
  </aha-modal>
</template>

<script>

export default {
  props: {
    presenter: {
      type: Object,
      default() {
        return {}
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.be-taken-over-modal {
  ::v-deep .aha-modal-content {
    width: 28rem;
  }
}
</style>
